import { render, staticRenderFns } from "./cancelShipment.vue?vue&type=template&id=4aacb082&scoped=true"
import script from "./cancelShipment.vue?vue&type=script&lang=js"
export * from "./cancelShipment.vue?vue&type=script&lang=js"
import style0 from "./cancelShipment.vue?vue&type=style&index=0&id=4aacb082&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aacb082",
  null
  
)

export default component.exports